import { render, staticRenderFns } from "./SidenavBlock.vue?vue&type=template&id=4ec87960&"
import script from "./SidenavBlock.vue?vue&type=script&lang=js&"
export * from "./SidenavBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports